import { GoabBadgeType } from '@abgov/ui-components-common';
import { Pipe, PipeTransform } from '@angular/core';
import { CapacityReportStatus } from '@libs/services/graphql/generated/ala-backend.service';

@Pipe({
  name: 'badgeTransform',
  standalone: true,
})
export class BadgeTransformPipe implements PipeTransform {
  public transform(val: CapacityReportStatus): GoabBadgeType {
    switch (val) {
      case CapacityReportStatus.NOTSTARTED:
        return 'important' as GoabBadgeType;
      case CapacityReportStatus.COMPLETED:
        return 'success' as GoabBadgeType;
      case CapacityReportStatus.INPROGRESS:
        return 'information' as GoabBadgeType;
      default:
        return 'information' as GoabBadgeType;
    }
  }
}
